namespace AgerLMS.Logging {
    export interface PaymentResponseLogForm {
        MethodName: Serenity.StringEditor;
        ServiceName: Serenity.StringEditor;
        PaymentId: Serenity.StringEditor;
        ConversationId: Serenity.StringEditor;
        PaymentLogType: Serenity.EnumEditor;
        Status: Serenity.StringEditor;
        RequestJson: Serenity.TextAreaEditor;
        ResponseJson: Serenity.TextAreaEditor;
        InsertDate: Serenity.DateEditor;
        IpNumber: Serenity.StringEditor;
    }

    export class PaymentResponseLogForm extends Serenity.PrefixedContext {
        static formKey = 'Logging.PaymentResponseLog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PaymentResponseLogForm.init)  {
                PaymentResponseLogForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.DateEditor;

                Q.initFormType(PaymentResponseLogForm, [
                    'MethodName', w0,
                    'ServiceName', w0,
                    'PaymentId', w0,
                    'ConversationId', w0,
                    'PaymentLogType', w1,
                    'Status', w0,
                    'RequestJson', w2,
                    'ResponseJson', w2,
                    'InsertDate', w3,
                    'IpNumber', w0
                ]);
            }
        }
    }
}
